<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <timeout-checker />
      <span class="font-weight-bold d-none d-sm-inline">{{ loggedUser.displayName }}</span>
      <i class="fa fa-fw fa-user fa-2x mr-4" style="vertical-align: middle;"></i>
    </template>
    <template slot="dropdown">
      <!--
      <b-dropdown-item>
        <i class="fa fa-fw fa-cog" /> Impostazioni
      </b-dropdown-item>
      -->
      <b-dropdown-item :to="{ name: 'ChangePassword' }">
        <i class="fa fa-fw fa-key" /> Cambia password
      </b-dropdown-item>
      <b-dropdown-item :to="{ name: 'Logout' }">
        <i class="fa fa-fw fa-sign-out" /> Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import HttpInterceptor from 'vue-core/auth/HttpInterceptor';

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  /*
  data: () => {
    return { itemsCount: 42 }
  }
  */
  computed: {
    loggedUser() {
      return HttpInterceptor.loggedUser
    }
  }
}
</script>
